(function () {
  "use strict";

  // ----------------------------------------------------------------------------------------------------------------
  // NATIVE CART DRAWER UNHIDE
  // ----------------------------------------------------------------------------------------------------------------
  //
  // Gokwik's remote SDK injects a sitewide rule (cart-drawer:not(html):not(body) { display:none
  // !important; ... }) that permanently hides the native drawer, by design, so its own sidecart is
  // the only visible cart UI. Setting the drawer's `open` attribute (what CartDrawer.show() does)
  // is therefore never enough on its own — the element stays invisible no matter what.
  //
  // This adds a more specific !important rule (cart-drawer[open] beats
  // cart-drawer:not(html):not(body) on specificity) that wins the cascade whenever we actually
  // want the native drawer to show. It's inert while the drawer is closed, so it's safe to load
  // unconditionally on every page.

  if (document.getElementById("zk-native-drawer-unhide")) return;
  var style = document.createElement("style");
  style.id = "zk-native-drawer-unhide";
  style.textContent =
    "cart-drawer[open]{display:flex!important;opacity:1!important;" +
    "width:auto!important;height:auto!important;visibility:visible!important;" +
    "pointer-events:auto!important;}";
  document.head.appendChild(style);
})();
